module.exports = __webpack_public_path__ + "img/Logo_iNoe.4b2eadd1.svg";